<template>
    <div class="certificates">
        <filters
            :data="filters"
            :initial="initial"
            @search="onChange"
        />
        <results
            :nav="nav"
            :data="list"
            v-if="list.length"
        />
        <z-preloader v-if="loading" />
        <z-not-found
            :text="text.notFoundText"
            :title="text.notFoundTitle"
            v-if="!list.length && !loading"
        />
        <z-pagination
            class="u-top-margin--double"
            show-next
            show-prev
            @change-page="onPageChange"
            v-if="list.length && !loading"
            :data="{
                pageRange: 1,
                totalItems: this.nav.count,
                totalPages: this.nav.total,
                currentPage: this.nav.current
            }"
        />
    </div>
</template>

<script>
import Results from './Results.vue'
import Filters from './Filters.vue'
import getCertificates from '@/api/certificates'
import { localize } from '@/utils/i18n'
import { debounce } from 'throttle-debounce'
import { queryString } from '@/utils/queryString'

export default {
    name: 'certificates',
    components: {
        Results,
        Filters
    },
    props: {
        initial: {
            type: Object,
            default: () => ({
                number123: '',
                type123: '',
                agency: '',
                description: '',
                factory: ''
            })
        }
    },
    data () {
        return {
            page: 1,
            loading: false,
            params: this.initial,
            data: this.$root.app.components.certificates,
            filters: {},
            nav: {},
            list: [],
            text: {
                showMore: localize({
                    ru: 'Показать еще',
                    en: 'Show more'
                }),
                notFoundTitle: localize({
                    ru: 'Ничего не&nbsp;найдено',
                    en: 'No&nbsp;results found'
                }),
                notFoundText: localize({
                    ru: 'По&nbsp;Вашему запросу ничего не&nbsp;нашлось.',
                    en: 'Sorry, no&nbsp;matches were found for your request. Try changing your search terms.'
                })
            }
        }
    },
    created () {
        if (this.data) {
            this.nav = this.data.nav
            this.list = this.data.items
            this.filters = this.data.filters
        }
    },
    methods: {
        onChange (data) {
            this.page = 1
            this.params = { ...data, page: this.page }
            this.send(this.clearEmptyParams(this.params))
        },
        onPageChange (page) {
            this.page = page
            this.params = { ...this.params, page: this.page }
            this.send(this.clearEmptyParams(this.params))
        },
        send: debounce(1000, function (params) {
            this.loading = true

            if (this.page === 1) this.list = []

            getCertificates(params, '/certificates/').then(res => {
                this.updateNav(res)
                this.updateList(res)
                this.updateFilters(res)

                queryString(params)

                this.loading = false
            })
        }),
        updateNav (res) {
            if (res.hasOwnProperty('nav')) {
                this.nav.current = res.nav.current
                this.nav.total = res.nav.total
                this.nav.count = res.nav.count
            }
        },
        updateList (res) {
            if (res.hasOwnProperty('items')) {
                this.list = res.items
            }
        },
        updateFilters (res) {
            if (res.hasOwnProperty('filters')) {
                if (Object.keys(res.filters).length) this.filters = res.filters
            }
        },
        clearEmptyParams () {
            let params = Object.assign({}, this.params)

            Object.keys(params).forEach(function (key, index) {
                if (Array.isArray(params[key])) {
                    if (!(params[key].filter(val => { return val !== null && val !== undefined && val !== '' }).length)) delete params[key]
                } else if (!params[key]) {
                    delete params[key]
                }
            })

            return params
        }
    }
}
</script>
